import { createGlobalStyle, css } from 'styled-components'

export const HpxGlobalStyleOverride = createGlobalStyle`
  && {
    ${({ theme: { isHpx } }) =>
      isHpx &&
      css`
        body {
          .instant-ink-enroll-hpx-button-override {
            &[disabled] {
              color: #ffffff;
            }
          }
          .instant-ink-enroll-hpx-button-override-checkout {
            &[disabled] {
              background-color: #edeefe;
            }
          }
          .instant-ink-enroll-hpx-secondary-button-override {
            &:not([disabled]) {
              color: var(--signup-secondary-text);
              border-color: var(--signup-secondary-border);

              &:hover {
                color: var(--signup-secondary-text);
                border-color: var(--signup-secondary-border);
              }

              &:active {
                background-color: var(--signup-royal-blue-3);
              }
            }
          }

          [data-testid='validations-modal'] button {
            &:not([disabled]) {
              color: var(--signup-secondary-text);
              border-color: var(--signup-secondary-border);

              &:hover {
                color: var(--signup-secondary-text);
                border-color: var(--signup-secondary-border);
              }

              &:active {
                background-color: var(--signup-royal-blue-3);
              }
            }
          }

          [data-testid='shipping-form'],
          [data-testid='ftm-shipping-step'] {
            input:focus,
            textarea:focus,
            [class*='InputField']:focus,
            [class*='FormControl']:focus-within {
              border-color: var(--signup-royal-blue-7) !important;
            }

            [class*='InputField']:focus-within,
            [class*='FormControl']:focus-within {
              border-color: var(--signup-royal-blue-7) !important;
            }
          }
        }
      `}
  }
`
